module.exports = require('./lib/input-moment');



//////////////////
// WEBPACK FOOTER
// ./~/input-moment/index.js
// module id = 1386
// module chunks = 2